// Pagine nascoste e irraggiungibili per ruolo/scope (2026-10-20, richiesta dell'utente): per un
// utente di livello partner con ruolo viewer non devono comparire né aprirsi Risky Assets,
// Whitelists, Responses/SOAR, Parser Lab e Platform Settings. Parser Lab e Platform Settings
// restano comunque solo platform (minScope nel menu, e qui per la route). Usato sia dal menu
// (components/Layout.tsx) sia dalle route (App.tsx): una pagina tolta dal menu ma raggiungibile
// via URL non è nascosta davvero.
export interface AccessUser { scopeLevel: 'platform' | 'partner' | 'tenant'; role: 'admin' | 'analyst' | 'viewer' }

const PLATFORM_ONLY = ['/parser-lab', '/settings'];
const HIDDEN_FOR_PARTNER_VIEWER = ['/risky-assets', '/whitelists', '/responses', '/parser-lab', '/settings'];

export function canAccessPath(user: AccessUser | null | undefined, path: string): boolean {
  if (!user) return false;
  if (PLATFORM_ONLY.includes(path) && user.scopeLevel !== 'platform') return false;
  if (user.scopeLevel === 'partner' && user.role === 'viewer' && HIDDEN_FOR_PARTNER_VIEWER.includes(path)) return false;
  return true;
}
